import axios from 'axios'
import { notification } from 'antd'
import { getAccessToken, msalInstance } from '../services/msalAuthService'
import { apiConfig } from '../config/authConfig'

const API_BASE_URL = apiConfig.uri

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'text/json',
  },
  // For HTTPS localhost development
  httpsAgent: {
    rejectUnauthorized: false
  }
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      // Try to get token from MSAL for Authorization header
      const token = await getAccessToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      // If MSAL fails, fallback to localStorage
      const user = JSON.parse(localStorage.getItem('user'))
      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`
      }
    }
    
    // Add app's access_token header for role validation (from login response tokenID)
    const accessToken = localStorage.getItem('access_token')
    if (accessToken) {
      config.headers['access_token'] = accessToken
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    //const status = error.response?.status
    //const data = error.response?.data
    
    // Skip notifications if on login page (login handles its own errors)
    const isLoginPage = window.location.pathname === '/login'
    // Login endpoint failures are handled by the Login component (redirects to /unauthorized)
    const isLoginRequest = error.config?.url?.includes('/Login/')
    
    if (error.response?.status === 401 && !isLoginRequest) {
      const accounts = msalInstance.getAllAccounts()
      if (accounts.length === 0) {
        // No MSAL session - redirect to login
        localStorage.removeItem('user')
        localStorage.removeItem('access_token')
        window.location.href = '/login'
      } else if (!isLoginPage) {
        // API 401 error - show notification message on current page (not on login page)
        notification.error({
          message: error.response?.data?.message,
          description: 'Authentication Error' ,
          duration: 5,
        })
      }
    } else if (error.response?.status === 403 && !isLoginPage) {
      // API 403 error - show notification message on current page (not on login page)
      notification.error({
        message: error.response?.data?.message,
        description: 'Access Denied' ,
        duration: 5,
      })
    }
    return Promise.reject(error)
  }
)

export default apiClient
